import { PropsWithChildren } from 'react'
import { NoDataPrompt, NoDataPromptProps } from '../NoDataPrompt'
import { QueryPaginatedProps } from './QueryPaginated'

export type QueryPaginatedNoDataProps<T> = PropsWithChildren<
  Partial<QueryPaginatedProps<T>> & NoDataPromptProps
>

export const QueryPaginatedNoData = <T,>({
  query,
  children,
  ...props
}: QueryPaginatedNoDataProps<T>) => {
  if (!query) throw new Error('Missing query data')

  const items = query.data?.items
  const hasNoItems =
    query.isSuccess && (!Array.isArray(items) || items.length === 0)

  if (hasNoItems)
    return children ? <>{children}</> : <NoDataPrompt {...props} />

  return null
}
